import type { IconSvgObject } from './types';

const PuzzleIcon: IconSvgObject = [
  ["path", { d: "M10 2C8.34315 2 7 3.34315 7 5V6H3C2.44772 6 2 6.44772 2 7V11H3C4.65685 11 6 12.3431 6 14C6 15.6569 4.65685 17 3 17H2V21C2 21.5523 2.44772 22 3 22H7V21C7 19.3431 8.34315 18 10 18C11.6569 18 13 19.3431 13 21V22H17C17.5523 22 18 21.5523 18 21V17H19C20.6569 17 22 15.6569 22 14C22 12.3431 20.6569 11 19 11H18V7C18 6.44772 17.5523 6 17 6H13V5C13 3.34315 11.6569 2 10 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default PuzzleIcon;
